import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUPS_OF_MANAGERS_LIST = Symbol('groups-of-managers');
export const GROUPS_OF_MANAGERS_ROUTE_NAME = Symbol('groups-of-managers');

export const GROUPS_OF_MANAGERS_LIST_QUERY_KEY = 'groups-of-managers.list';
export const GROUPS_OF_MANAGERS_LIST_API_URL = 'admin/admin_groups/admins_of_group';

export const GROUPS_OF_MANAGERS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.ADMINGROUPS_SHOW),
};
